import { StateCategory } from '../../../reusable/Category/state/types'
import { SearchAction, SearchActionType, SearchScreen, SearchState } from './types'

const INITIAL_SEARCH_STATE: SearchState = {
  screen: SearchScreen.INITIAL,
  searchValue: '',
  isCategoriesLoading: false,
  categories: [],
  isSearchFocused: false,
}
export const getInitialState = ({ savedCategory }: { savedCategory?: StateCategory }): SearchState => ({
  ...INITIAL_SEARCH_STATE,
  selectedCategory: savedCategory
    ? {
        businessTerm: savedCategory.businessTerm,
        businessSegmentId: savedCategory.businessSegmentId,
        index: savedCategory.index,
      }
    : undefined,
})

export const searchStateReducer = (state: SearchState, action: SearchAction): SearchState => {
  if (action.type === SearchActionType.SEARCH_FOCUS) {
    switch (state.screen) {
      case SearchScreen.INITIAL:
        return {
          ...state,
          isSearchFocused: true,
          screen: SearchScreen.SEARCH_SUGGESTIONS_ACTIVE,
        }
      case SearchScreen.SEARCH_SUGGESTIONS_ACTIVE:
      case SearchScreen.SEARCH_CATEGORIES_RESULTS_ACTIVE: {
        return {
          ...state,
          isSearchFocused: true,
        }
      }
      default:
        return state
    }
  } else if (action.type === SearchActionType.SEARCH_BLUR) {
    switch (state.screen) {
      case SearchScreen.SEARCH_SUGGESTIONS_ACTIVE:
        return {
          ...state,
          isSearchFocused: false,
          screen: SearchScreen.SEARCH_SUGGESTIONS_ACTIVE,
        }
      case SearchScreen.SEARCH_CATEGORIES_RESULTS_ACTIVE: {
        return {
          ...state,
          isSearchFocused: false,
        }
      }
      default:
        return state
    }
  } else if (action.type === SearchActionType.SEARCH_SELECT_SUGGESTION) {
    return {
      ...state,
      screen: SearchScreen.SEARCH_CATEGORIES_RESULTS_ACTIVE,
      searchValue: action.suggestion,
    }
  } else if (action.type === SearchActionType.SEARCH_LOAD_CATEGORIES_START) {
    return {
      ...state,
      isCategoriesLoading: true,
    }
  } else if (action.type === SearchActionType.SEARCH_LOAD_CATEGORIES_SUCCESS) {
    return {
      ...state,
      isCategoriesLoading: false,
      categories: action.categories,
    }
  } else if (action.type === SearchActionType.SEARCH_CHANGE) {
    return {
      ...state,
      screen: SearchScreen.SEARCH_CATEGORIES_RESULTS_ACTIVE,
      searchValue: action.value,
    }
  } else if (action.type === SearchActionType.SEARCH_EMPTY) {
    switch (state.screen) {
      case SearchScreen.SEARCH_CATEGORIES_RESULTS_ACTIVE:
        return {
          ...state,
          searchValue: '',
          selectedCategory: undefined,
          screen: SearchScreen.SEARCH_SUGGESTIONS_ACTIVE,
        }
      default:
        return state
    }
  } else if (action.type === SearchActionType.SEARCH_SELECT_CATEGORY) {
    return {
      ...state,
      selectedCategory: action.category,
      searchValue: action.category.businessTerm?.displayName ?? '',
    }
  } else if (action.type === SearchActionType.TO_INITIAL_SCREEN) {
    return {
      ...state,
      screen: SearchScreen.INITIAL,
    }
  }

  return state
}
